// TODO: use SVG as icon so colors can be set via CSS

/**
 * Chevron to the right that is shown when there are content related to the item
 */
import React from 'react';
import Icon from '../icons/Icon';
import stylesheet from './RightChevron.module.scss';

/**
 * A component that renders a right-pointing chevron icon.
 *
 * @param {Object} props - The component props.
 * @param {string} [props.className] - Additional CSS class names.
 * @param {string} [props.color='#515151'] - The color of the chevron icon.
 * @param {Object} [props.style] - Additional styles for the icon.
 */
const RightChevron = (props) => {
    const { className = '', color = '#515151', style } = props;

    return <Icon className={[stylesheet.RightChevron, className].join(' ')} src="/img/arrow_event@3x.png" color={color} style={style} />;
};

export default RightChevron;
